import {z} from 'zod'
import {FilterItemSchema} from '@hooks/useFilterMeasures.tsx'

export const SUB_TYPES = z.enum([
    'judgment',
    'short_judgment',
    'interlocutory_opinion',
    'final_opinion',
    'judgment_device',
    'suspensive_opinion',
    'opinion',
    'precautionary_decree',
    'collegiate_decree',
    'dispositive_decree',
    'injunction_decree',
    'presidential_decree',
    'legal_aid',
    'precautionary_order',
    'collegial_order',
    'injunction_order',
    'presidential_order'
])

export type SUB_TYPES = z.infer<typeof SUB_TYPES>

export const Measure = z.object({
    appealNumber: z.number().nullish(),
    headquarterLocation: z.object({
        id: z.string(),
        keyName: z.string(),
        keyTarName: z.string()
    }),
    headquarterLocationId: z.string(),
    id: z.string(),
    isOmissis: z.boolean(),
    measureNumber: z.number(),
    publishedAt: z.string().nullish(),
    sectionId: z.string(),
    subType: SUB_TYPES,
    type: z.enum(['judgment', 'opinion', 'decree', 'ordinance']),
    rawContent: z.string().optional(),
    involvedParties: z.array(
        z.object({
            id: z.string(),
            name: z.string()
        })
    ),
    judicialPanels: z.array(
        z.object({
            id: z.string(),
            name: z.string()
        })
    ),
    section: z.object({
        id: z.string(),
        keyName: z.string()
    }),

    appealMeasureId: z.string().nullable(),
    highlight: z.string().optional(),
    pqmSection: z.string().nullable()
})

export type Measure = z.infer<typeof Measure>

export const QuerySearchParams = z.object({
    query: z.string().optional()
})

export const Filters = z.object({
    activeTab: z.enum(['all', 'opinion', 'judgment', 'decree', 'ordinance']),
    type_of_measure: z.array(FilterItemSchema),
    general_role: z.array(FilterItemSchema),
    site: z.array(FilterItemSchema),
    counter_part: z.array(FilterItemSchema),
    section: z.array(FilterItemSchema),
    panel: z.array(FilterItemSchema),
    orderBy: z.enum(['publishedAt', 'site']).nullable(),
    orderDirection: z.enum(['asc', 'desc']),
    general_number: z.string().optional(),
    search: z.string().optional(),
    page: z.number(),
    perPage: z.number()
})

export type Filters = z.infer<typeof Filters>
